import MuiError from "@material-ui/icons/Error";
import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';
import { Box } from "rebass";

const ErrorIcon = styled(MuiError)`
  color: ${(props) => props.theme.colors.red}
  margin-right: 5px;
  vertical-align: middle;
`;

const Wrapper = styled(Box)`
  vertical-align: middle;
  display: inline-block;
`;

const Error = ({ message }) => (
  <Box>
    <ErrorIcon />
    <Wrapper>{message}</Wrapper>
  </Box>
);

Error.propTypes = {
  message: PropTypes.string
};

export default Error;


// WEBPACK FOOTER //
// ./src/components/Error.jsx